import http from 'hub-http/clients/apiClient';
import { BASE_URL } from '../constants/urls';
export const getAudience = id => http.get(`${BASE_URL}/${id}`);
export default getAudience;